export default "__VITE_ASSET__IAM_MteL__"